var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"font-weight-bold normal_simple_solid_button",attrs:{"color":"#FFFFFF","block":"","elevation":"0","height":"44px"},on:{"click":_vm.clickAction}},[_c('p',[_vm._v(_vm._s(_vm.buttonTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }